import { useState } from "react";
import { Container, Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import { BreadcrumbItem } from "reactstrap";
import { useHistory } from "react-router-dom";
import * as Notify from "@repoflow/form-schema/notify";
import * as OrganizationUsersQL from "queries/organization-user";
import { CancellableContent } from "@repoflow/components/content-cancel";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import * as tags from "@repoflow/form-schema/widgets/tag";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>New</BreadcrumbItem>;


export const Content = ({
  match: {
    params,
    params: { domain, orgId },
  },
}) => {
  const { base } = useSectionContext();
  const [phase, setPhase] = useState("init");
  const history = useHistory();

  const initial = {
    roles: [],
  };
  return (
    <Mutation
      initial={initial}
      context={{
        phase
      }}
      target={{ $ref: "/Public/OrganizationUsers/Invite" }}
      mutation={OrganizationUsersQL.invite}
      update={OrganizationUsersQL.update(params)}
      onMutate={({ state: { values }, handler }) => {
        setPhase("loading");

        handler({
          variables: {
            domain,
            orgId,
            input: values,
          },
        });
      }}
      onCompleted={(data) => {
        history.replace(base);
      }}
      onError={(error) => {
        // Without this the Create button keeps spinning, disabled, forever.
        setPhase("init");
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({
  schema,
  state,
  mutate,
  context: {
    phase,
  },
  target,
}) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    onSubmit: () => {
      mutate();
    },
    onChange: (vals) => {
      setValues(vals);
    },
    config: {
      // Must match the target above. This said .../Create, which is not a
      // type in the schema, so the field list was silently ignored.
      "/Public/OrganizationUsers/Invite": {
        fields: [
          "email", "roles"
        ],
      },
    },
    values,
    widgets: { tags }
  };


  return (
    <CancellableContent>
   

      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit" loading={phase === "loading"}>
                Invite
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
